import _extends from "../../../../@babel/runtime/helpers/esm/extends.es.js";
import _objectWithoutPropertiesLoose from "../../../../@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.es.js";
import * as React from "react";
import { clsx } from "../../../../clsx/dist/clsx.es.js";
import { styled } from "@mui/system";
import { getDataGridUtilityClass } from "../../constants/gridClasses.es.js";
import { useGridRootProps } from "../../hooks/utils/useGridRootProps.es.js";
import { j as jsxRuntimeExports } from "../../../../react/jsx-runtime.es.js";
import composeClasses from "../../../utils/composeClasses/composeClasses.es.js";
const _excluded = ["className"];
const useUtilityClasses = (ownerState) => {
  const {
    classes
  } = ownerState;
  const slots = {
    root: ["columnHeaders", "withBorderColor"]
  };
  return composeClasses(slots, getDataGridUtilityClass, classes);
};
const GridColumnHeadersRoot = styled("div", {
  name: "MuiDataGrid",
  slot: "ColumnHeaders",
  overridesResolver: (props, styles) => styles.columnHeaders
})({
  position: "relative",
  overflow: "hidden",
  display: "flex",
  alignItems: "center",
  boxSizing: "border-box",
  borderBottom: "1px solid",
  borderTopLeftRadius: "var(--unstable_DataGrid-radius)",
  borderTopRightRadius: "var(--unstable_DataGrid-radius)"
});
const GridBaseColumnHeaders = /* @__PURE__ */ React.forwardRef(function GridColumnHeaders(props, ref) {
  const {
    className
  } = props, other = _objectWithoutPropertiesLoose(props, _excluded);
  const rootProps = useGridRootProps();
  const classes = useUtilityClasses(rootProps);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(GridColumnHeadersRoot, _extends({
    ref,
    className: clsx(className, classes.root),
    ownerState: rootProps
  }, other, {
    role: "presentation"
  }));
});
export {
  GridBaseColumnHeaders
};
//# sourceMappingURL=GridBaseColumnHeaders.es.js.map
